export function persistFileTypePatcher(data) {
    return {
        __typename: 'PersistFile',
        ...data,
        persistFile: {
            __typename: 'PersistFile',
            ...data.persistFile,
        },
    };
}
